export default __webpack_public_path__ + "media/images/coworkr/favicons/icon114-cbdd2181360f6c1268c507312d489772.png";